import { render } from "./warning.vue?vue&type=template&id=61df93bc&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import "./warning.vue?vue&type=style&index=0&id=61df93bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61df93bc"]])

export default __exports__